import type { LineChartReportCardProps } from '../../AnalyticsDashboard.types'
import { useLineChartReportCard } from '../useLineChartReportCard'

const reportId = 'average_order_value'

export const useAverageOrderValueReportCard = (): LineChartReportCardProps => {
  return useLineChartReportCard({
    reportId,
    headerLabel: 'Average shop order value',
    headerTooltipTitle: 'Average shop order value',
    headerTooltipDescription: 'Average amount paid by customer per order.',
  })
}
